module.exports = __webpack_public_path__ + "static/img/tab-service-s2.08acb37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tab-service-s2.png
// module id = +Jm8
// module chunks = 0